module.exports = __webpack_public_path__ + "static/media/IrAliceChow.277bad5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/comp/sub2/IrAliceChow.jpg
// module id = 206
// module chunks = 0